import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src", "0", "1"];
import { jsx as _jsx } from "react/jsx-runtime";
const SVGBase = props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("svg", Object.assign({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest));
};
export default SVGBase;